// extracted by mini-css-extract-plugin
module.exports = {"wrapperDiv":"style_wrapperDiv__3Qpfp"};